import {
	SET_FORM_STATE,
	SET_INITIAL_STATE,
	GET_USERS,
	GET_PENDING_USERS,
	GET_USERS_STATS,
	TOGGLE_ADD_EDIT_USER_DIALOG,
	TOGGLE_ADD_PENDING_USERS_DIALOG,
	TOGGLE_DELETE_USER_DIALOG,
	GET_ROLES,
	GET_OPERATORS,
	GET_OPERATOR_PROJECTS,
	GET_USER
} from '../actions/UsersActions.js';

const initialState = {
	users: [],
	pendingUsers: [],
	usersStats: {},
	openAddEditUserDialog: false,
	openAddEditUserDialogId: null,
	openAddPendingUsersDialog: false,
	openDeleteUserDialog: false,
	openDeleteUserDialogId: null,
	roles: [],
	operators: [],
	operatorProjects: [],
	formState: {
		isValid: false,
		values: {},
		touched: {},
		errors: {},
	}
};

const usersReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							formState: action.formState
						};
					}
					case SET_INITIAL_STATE: {
						return {
							...state,
							formState: initialState.formState,
						};
					}
					case GET_USERS: {
						return {
							...state,
							users: action.users
						};
					}
					case GET_PENDING_USERS: {
						return {
							...state,
							pendingUsers: action.pendingUsers
						};
					}
					case GET_USERS_STATS: {
						return {
							...state,
							usersStats: action.usersStats
						};
					}
					case TOGGLE_ADD_EDIT_USER_DIALOG: {
						return {
							...state,
							openAddEditUserDialog: action.openAddEditUserDialog,
							openAddEditUserDialogId: action.openAddEditUserDialogId,
							// formState: initialState.formState,
							roles: [],
							operators: [],
							operatorProjects: [],
						};
					}
					case TOGGLE_ADD_PENDING_USERS_DIALOG: {
						return {
							...state,
							formState: initialState.formState,
							openAddPendingUsersDialog: action.openAddPendingUsersDialog,
						};
					}
					case TOGGLE_DELETE_USER_DIALOG: {
						return {
							...state,
							openDeleteUserDialog: action.openDeleteUserDialog,
							openDeleteUserDialogId: action.openDeleteUserDialogId
						};
					}
					case GET_ROLES: {
						return {
							...state,
							roles: action.roles
						};
					}
					case GET_OPERATORS: {
						return {
							...state,
							operators: action.operators
						};
					}
					case GET_OPERATOR_PROJECTS: {
						return {
							...state,
							operatorProjects: action.operatorProjects
						};
					}
					case GET_USER: {
						return {
							...state,
							formState: {
								...state.formState,
								values: { ...action.user }
							}
						};
					}
					default: {
						return state;
					}
	}
};

export default usersReducer;
